module.exports = __webpack_public_path__ + "img/customer6.78cf9cec.jpg";